import { ProgramException } from 'libs/errors/ProgramException'

export const GENERIC_ERROR = new ProgramException('Please try again or contact support.')
